import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { EgiftCardsFacadeService } from 'src/app/modules/e-gift-cards/services/e-gift-cards-facade.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-print-product-table',
  templateUrl: './print-product-table.component.html',
  styleUrls: ['./print-product-table.component.scss']
})
export class PrintProductTableComponent implements OnInit {
  productList: any = [];
  public cardTypes = environment.card_types;
  suggestionCards = [];
  showingRangeProducts = [];


  constructor(
    private eGiftCardsService: EgiftCardsFacadeService,
    private loaderService: LoaderService
  ) { }

  ngOnInit(
  ): void {
    this.getFullProductList();
  }

  getFullProductList() {
    const params = [
      {
        key: "card_type",
        value: this.cardTypes.digital.toString(),
      }
    ];

    let limit = 10000;
    let offset = 0;
    this.loaderService.show();
    this.eGiftCardsService
      .getProductList(limit, offset, params)
      .subscribe((data) => {
        this.loaderService.hide();

        for (let product of data.results) {
          this.productList.push(product);
          for (let suggestion of product['suggestions']) {
            let product_d = { ...product }
            product_d['title'] = `${product_d['title']} ${suggestion['title']}`
            product_d['price_min'] = suggestion['price'];
            product_d['price_max'] = suggestion['price'];
            product_d['upc'] = suggestion['upc'] || product['upc'];
            this.productList.push(product_d)
          }
        }
      });
  }
}
